import type { GridColDef } from '@mui/x-data-grid';
import type { AffectedMeteredEventSample } from '@vy/types';
import { vyDate, getOptionalObjectProperty, type ValueOf } from '@vy/utils';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../../../../../../utils/date';

export const AFFECTED_METERED_EVENT_COLUMNS_KEYS = Object.freeze({
  NAME: 'name',
  VALUE: 'value',
  ASSIGNED_AT: 'assignedAt',
});

export type AffectedMeteredEventsColumnsKey = ValueOf<typeof AFFECTED_METERED_EVENT_COLUMNS_KEYS>;

export function buildAffectedMeteredEventsTableColumns(
  meterNameIdMap: Record<string, { name: string }>,
): GridColDef<AffectedMeteredEventSample>[] {
  return [
    {
      field: AFFECTED_METERED_EVENT_COLUMNS_KEYS.NAME,
      valueGetter: (_value, row) => row.meterId,
      headerName: 'Name',
      flex: 1,
      renderCell: ({ value }) => (
        <Link
          to={`/products/${value}/edit`}
          state={meterNameIdMap[value]}
          onMouseEnter={(event) => (event.currentTarget.style.textDecoration = 'underline')}
          onMouseLeave={(event) => (event.currentTarget.style.textDecoration = 'none')}
        >
          {getOptionalObjectProperty(meterNameIdMap[value], 'name')}
        </Link>
      ),
    },
    {
      field: AFFECTED_METERED_EVENT_COLUMNS_KEYS.VALUE,
      valueGetter: (_value, row) => row.value,
      headerName: 'Value',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: ({ value }) => <span className="font-sans text-black">{value}</span>,
    },
    {
      field: AFFECTED_METERED_EVENT_COLUMNS_KEYS.ASSIGNED_AT,
      valueGetter: (_value, row) => row.assignedAt,
      headerName: 'Matched At',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      renderCell: ({ value }) => <span className="font-sans text-black">{formatDate(vyDate(value))}</span>,
    },
  ];
}
